import { asyncHelper } from 'utils/asyncHelper';

let isScriptLoaded = false;

const appendScript = () =>
    new Promise((resolve) => {
        const script = document.createElement('script');
        const finish = (event) => {
            window.clearTimeout(timeoutId);
            isScriptLoaded = event && event.type === 'load';
            resolve();
        };

        const timeoutId = window.setTimeout(finish, 3000);
        script.async = true;
        script.src = 'https://cdn.fraudlabspro.com/s.js';
        script.onload = finish;
        script.onerror = finish;
        document.body.appendChild(script);
    });

export const FraudLabs = {
    async loadAgent() {
        if (!isScriptLoaded) {
            await appendScript();
            await asyncHelper.delay(500);
        }
    },
};
